import { render, staticRenderFns } from "./sc.vue?vue&type=template&id=4ed6f452&scoped=true&"
import script from "./sc.vue?vue&type=script&lang=js&"
export * from "./sc.vue?vue&type=script&lang=js&"
import style0 from "./sc.vue?vue&type=style&index=0&id=4ed6f452&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed6f452",
  null
  
)

export default component.exports